export const getSitecoreDatasource = ({
  shop,
  itemName,
}: {
  shop: string;
  itemName: string;
}): string => {
  const normalizedShop =
    shop.charAt(0).toUpperCase() + shop.slice(1).toLowerCase();
  return `/sitecore/content/Shops/${normalizedShop}/${normalizedShop}-Com/Data/${itemName}`;
};
